'use client';

import React from 'react';
import { X, Trash2, Forward, Star } from 'lucide-react';

interface SelectionHeaderProps {
  count: number;
  onCancel: () => void;
  onDelete: () => void;
}

export default function SelectionHeader({ count, onCancel, onDelete }: SelectionHeaderProps) {
  return (
    <header
      className="flex items-center gap-3 px-3 sm:px-4 h-[56px] sm:h-[60px] flex-shrink-0 z-10 relative animate-slide-down"
      style={{ backgroundColor: 'var(--selection-header)', borderBottom: '1px solid var(--composer-border)' }}
      role="toolbar"
      aria-label="Message selection toolbar"
    >
      <button
        onClick={onCancel}
        className="flex items-center justify-center w-10 h-10 rounded-full hover:bg-white/10 transition-colors duration-150 active:scale-90"
        aria-label="Cancel selection"
      >
        <X size={20} className="text-white" />
      </button>

      <span className="flex-1 text-white font-semibold text-[15px]">
        {count} selected
      </span>

      <div className="flex items-center gap-0.5">
        <SelectionAction icon={<Forward size={19} />} label="Forward selected" onClick={() => {}} />
        <SelectionAction icon={<Star size={19} />} label="Star selected" onClick={() => {}} />
        <SelectionAction icon={<Trash2 size={19} />} label="Delete selected" onClick={onDelete} />
      </div>
    </header>
  );
}

function SelectionAction({ icon, label, onClick }: { icon: React.ReactNode; label: string; onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      title={label}
      aria-label={label}
      className="flex items-center justify-center w-10 h-10 rounded-full hover:bg-white/10 transition-colors duration-150 active:scale-90 text-white"
    >
      {icon}
    </button>
  );
}